<div class="flip-body">
  <div *ngIf="!flipped" class="front-container">
    <ng-content select="app-flip-front"></ng-content>
  </div>
  <div *ngIf="flipped" class="back-container">
    <ng-content select="app-flip-back"></ng-content>
  </div>
</div>
